import { render, staticRenderFns } from "./MyCovoits.vue?vue&type=template&id=4185451e&scoped=true"
import script from "./MyCovoits.vue?vue&type=script&lang=js"
export * from "./MyCovoits.vue?vue&type=script&lang=js"
import style0 from "./MyCovoits.vue?vue&type=style&index=0&id=4185451e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4185451e",
  null
  
)

export default component.exports